import "./polyfills";
import React from "react";
import ReactDOM from "react-dom";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import "assets/scss/resolutionChat/chat.scss";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/index";
import * as Sentry from "@sentry/react";
import { browserTracingIntegration } from "@sentry/react";

if (process.env.NODE_ENV === "production") {
  Sentry.init({
    dsn: "https://1389f83d1ead5c98ad2569deef356717@o4507571489210368.ingest.de.sentry.io/4508992651198544",
    integrations: [browserTracingIntegration()],
    tracesSampleRate: 1.0,
    environment: "production",
  });
}

ReactDOM.render(
  <>
    <Provider store={store}>
      <Sentry.ErrorBoundary
        fallback={
          <div className="d-flex flex-column align-items-center justify-content-center text-danger py-10">
            <div className="fw-bold text-center fs-1">
              Something went wrong. Please try again later. 🚨
            </div>
          </div>
        }
      >
        <ToastContainer limit={1} />
        <App />
      </Sentry.ErrorBoundary>
    </Provider>
  </>,
  document.getElementById("root")
);

serviceWorkerRegistration.register();
